import { render, staticRenderFns } from "./page-blog-detail-two.vue?vue&type=template&id=4e646502&"
import script from "./page-blog-detail-two.vue?vue&type=script&lang=js&"
export * from "./page-blog-detail-two.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports